export default __webpack_public_path__ + "static/media/workshop4.8d5cb54a.jpg";